import React from 'react'
import { useTranslation } from 'react-i18next'
import { MenuItem } from '@material-ui/core'

import { UserRole } from 'types/UserRole'
import { COMPANY_ROLE, TEACHER_ROLE, PARTICIPANT_ROLE, CONTENT_CREATOR_ROLE, ADMIN_ROLE } from 'constants/roleGroups'
import { Select, SelectProps } from 'components/inputs/Select/Select'
import { useUserRole } from 'providers/UserContextProvider'

const RoleSelect: React.FC<SelectProps> = ({
  ...rest
}) => {
  const { t } = useTranslation()
  const userRole = useUserRole()

  const roles: UserRole[] = [PARTICIPANT_ROLE, TEACHER_ROLE, CONTENT_CREATOR_ROLE, COMPANY_ROLE]

  const canEditCompany = userRole === ADMIN_ROLE || userRole === COMPANY_ROLE

  return (
    <Select
      {...rest}
    >
      <MenuItem disabled value=''>
        {t('common.roles')}
      </MenuItem>
      {roles.map((role) => (
        <MenuItem key={role} value={role} disabled={role === COMPANY_ROLE && !canEditCompany}>
          {t(`roles.${role}`)}
        </MenuItem>
      ))}
    </Select>
  )
}

export { RoleSelect }
